<!-- 站内信管理 -->
<template>
  <div class="webSiteMsgManagement">
    <div class="nav-bar">
      <div class="nav-left">
        <el-form inline>
          <el-form-item label="站内信标题:">
            <el-input v-model.trim="query.title" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="站内信状态:">
            <el-select v-model="query.status" class="select" placeholder="请选择" :clearable="true">
              <template v-for="item in msgStatus">
                <el-option :key="item.key" :label="item.label" :value="item.key" />
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="站内信发布时间:">
            <el-date-picker
              v-model="query.time"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              value-format="timestamp"
              :editable="false"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="nav-right">
        <el-button type="primary" @click="handleBtn('筛选')">筛选</el-button>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="nav-bar">
      <div class="nav-left"></div>
      <div class="nav-right">
        <el-button type="primary" @click="handleBtn('新建站内信')">新建站内信</el-button>
      </div>
    </div>
    <el-table v-loading="tableLoading" :data="tableData" style="width: 100%; font-size: 14px">
      <el-table-column prop="title" label="站内信标题">
        <template slot-scope="scope">
          <el-tooltip
            popper-class="table_tooltip"
            effect="dark"
            :content="scope.row.title"
            placement="top"
          >
            <Ellipsis :str="scope.row.title" suffix="..." :max-length="10"></Ellipsis>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="站内信内容">
        <template slot-scope="scope">
          <el-tooltip
            popper-class="table_tooltip"
            effect="dark"
            :content="scope.row.content"
            placement="top"
          >
            <Ellipsis :str="scope.row.content" suffix="..." :max-length="20"></Ellipsis>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="operator.name" label="发布人"></el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          {{ scope.row.status | filterMsgStatus }}
        </template>
      </el-table-column>
      <el-table-column prop="publish_time" label="发布时间">
        <template slot-scope="scope">
          {{ scope.row.publish_time | filterTime }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <!--  如果发布了， 显示撤回 隐藏编辑和删除 -->
        <template slot-scope="scope">
          <el-button
            @click="openDialog({ action: '查看详情', row: scope.row })"
            type="text"
            size="small"
            style="font-size: 14px"
          >
            查看详情
          </el-button>
          <!-- 已发布 -->
          <template v-if="scope.row.status === 2">
            <el-button type="text" size="small" style="letter-spacing: 21px; font-size: 14px">
              -
            </el-button>
            <el-button
              @click="openDialog({ action: '撤回', row: scope.row })"
              type="text"
              size="small"
              style="font-size: 14px"
            >
              撤回
            </el-button>
            <el-button type="text" size="small" style="letter-spacing: 21px; font-size: 14px">
              -
            </el-button>
          </template>
          <!-- 未发布 -->
          <template v-else>
            <el-button
              @click="tableActionFun({ action: '编辑', row: scope.row })"
              type="text"
              size="small"
              style="font-size: 14px"
            >
              编辑
            </el-button>
            <el-button
              @click="openDialog({ action: '发布', row: scope.row })"
              type="text"
              size="small"
              style="font-size: 14px"
            >
              发布
            </el-button>
            <el-button
              @click="openDialog({ action: '删除', row: scope.row })"
              type="text"
              size="small"
              style="font-size: 14px"
            >
              删除
            </el-button>
          </template>
        </template>
      </el-table-column>
      <div slot="empty"><NoData></NoData></div>
    </el-table>
    <el-pagination
      class="pagination"
      style="background-color: #ffffff"
      :current-page="tableCurPage"
      :page-size="tablePageSize"
      :total="tableTotal"
      @current-change="currentChangeFun"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="g_pageSizesConfig"
      @size-change="handleSizeChange"
    />
    <!-- 新建站内信 -->
    <ConfigDialog
      config-name="addExanBank"
      :dialog-visible.sync="configDialogVisible"
      @dialogEmit="dialogEmit"
    ></ConfigDialog>
    <!-- 查看详情 -->
    <el-dialog title="查看详情" :visible.sync="detailDialogVisible" width="35%" center>
      <el-form
        ref="form"
        :model="detailForm"
        label-width="130px"
        class="form_box"
        v-loading="detailDialogLoading"
      >
        <el-form-item label="站内信标题:">
          {{ detailForm.title }}
        </el-form-item>
        <el-form-item label="站内信内容:" class="account_select">
          {{ detailForm.content }}
        </el-form-item>
        <el-form-item label="发布范围:" class="account_select">
          <SelectViewRange
            v-if="detailForm.user_ids.length || detailForm.dept_ids.length"
            ref="viewRangeAll"
            :user-id-list="detailForm.user_ids"
            :department-id-list="detailForm.dept_ids"
            :disable-selection="true"
          ></SelectViewRange>
        </el-form-item>
        <el-form-item label="发布状态:" class="account_select">
          {{ detailForm.status | filterMsgStatus }}
        </el-form-item>
        <el-form-item label="发布人:" class="account_select">
          {{ detailForm.operator ? detailForm.operator.name : '-' }}
        </el-form-item>
        <el-form-item label="发布时间:" class="account_select">
          {{ detailForm.publish_time | filterTime }}
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="
            () => {
              detailDialogVisible = false;
            }
          "
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
    <!-- 删除 -->
    <el-dialog title="删除提示" :visible.sync="delDialogVisible" width="30%" center>
      <div style="text-align: center">删除后无法恢复，确定删除吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialogVisible = false">取 消</el-button>
        <el-button
          type="danger"
          @click="
            () => {
              delDialogVisible = false;
              tableActionFun({ action: '删除', row: rowTemp });
            }
          "
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
    <!-- 发布 -->
    <el-dialog title="发布提示" :visible.sync="publicDialogVisible" width="30%" center>
      <div style="text-align: center">确定发布此条站内信吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="publicDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="
            () => {
              publicDialogVisible = false;
              tableActionFun({ action: '发布', row: rowTemp });
            }
          "
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
    <!-- 撤回 -->
    <el-dialog title="撤回提示" :visible.sync="backDialogVisible" width="30%" center>
      <div style="text-align: center">撤回后已接收的用户不可再见，确定要撤回吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="
            () => {
              backDialogVisible = false;
              tableActionFun({ action: '撤回', row: rowTemp });
            }
          "
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinTable } from './mixin/table.js';
import Ellipsis from '@/components/ellipsis';
import SelectViewRange from '@/components/selectViewRange';
import {
  GetInMailList,
  DelInMail,
  PubInMailById,
  WithdrawInMailById,
  GetInMailDetail,
} from '@/api/webSiteMsgManagement';
// 如果发布了， 显示撤回 隐藏编辑和删除
const msgStatus = [
  { label: '全部', key: 4 },
  { label: '未发布', key: 1 },
  { label: '已发布', key: 2 },
  { label: '已撤回', key: 3 },
  // { label: '已删除', key: 0 },
];
export default {
  name: 'WebSiteMsgManagement',
  components: { Ellipsis, SelectViewRange },
  filters: {
    // 过滤状态中文名
    filterMsgStatus(value) {
      let txt = '';
      msgStatus.forEach((_) => {
        if (_.key === value) {
          txt = _.label;
        }
      });
      return txt;
    },
  },
  mixins: [mixinTable],
  props: {},
  data() {
    return {
      // 筛选------------
      query: {
        title: '',
        status: '',
        time: '',
      },
      // 站内信状态------------
      msgStatus,
      // 弹窗------------
      publicDialogVisible: false, // 发布
      delDialogVisible: false, // 删除
      backDialogVisible: false, // 撤回
      detailDialogVisible: false, // 查看详情
      // 查看详情 ------------
      detailDialogLoading: false, // 查看详情加载
      detailForm: {
        title: '', // 标题
        content: '', // 内容
        status: '', // 状态
        operator: { name: '' }, // 操作者
        publish_time: '', // 发布时间
        user_ids: [], // 发布目标成员
        dept_ids: [], // 发布目标部门
      },
    };
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    // 查询表格列表
    async getTaleData() {
      this.tableLoading = true;
      try {
        const res = await GetInMailList({
          page_index: this.tableCurPage, // 分页码
          page_size: this.tablePageSize, // 每页条数
          title: this.query.title || undefined,
          status: this.query.status || undefined,
          stime: this.query.time && this.query.time[0] ? this.query.time[0] / 1000 : undefined,
          etime: this.query.time && this.query.time[1] ? this.query.time[1] / 1000 : undefined,
        });
        this.tableTotal = res.total || 0;
        this.tableData = res.records || [];
      } catch (error) {
        this.$message.error(error.message);
        this.tableLoading = false;
      }
      this.tableLoading = false;
    },
    /** 表格操作
     * @description: 表格操作事件
     * @param {string} action 操作名称
     * @param {object} row 操作行数据
     * @return {*} void
     */
    async tableActionFun({ action, row }) {
      switch (action) {
        case '查看详情':
          break;
        case '编辑':
          this.g_tourl(`/saas/webSiteMsgManagement/add.html?id=${row.id}`);
          break;
        case '发布':
          // 发布=>重新请求数据
          this.tableLoading = true;
          try {
            await PubInMailById({
              id: row.id,
            });
            this.$message.success('发布成功');
            this.getTaleData();
          } catch (error) {
            this.$message.error(error.message);
          }
          this.tableLoading = false;
          break;
        case '撤回':
          // 撤回=>重新请求数据
          this.tableLoading = true;
          try {
            await WithdrawInMailById({
              id: row.id,
            });
            this.$message.success('撤回成功');
            this.getTaleData();
          } catch (error) {
            this.$message.error(error.message);
          }
          this.tableLoading = false;
          break;
        case '删除':
          // 删除=>重新请求数据
          this.tableLoading = true;
          try {
            await DelInMail({
              id: row.id,
            });
            this.$message.success('删除成功');
            this.getTaleData();
          } catch (error) {
            this.$message.error(error.message);
          }
          this.tableLoading = false;
          break;
        default:
          break;
      }
    },
    // 打开弹窗
    async openDialog({ action, row }) {
      switch (action) {
        case '查看详情':
          this.detailDialogLoading = true;
          this.detailDialogVisible = true;
          this.rowTemp = row;
          try {
            this.detailForm = await GetInMailDetail({
              id: row.id,
            });
          } catch (error) {
            this.$message.error(error.message);
          }
          this.detailDialogLoading = false;
          break;
        case '发布':
          this.publicDialogVisible = true;
          this.rowTemp = row;
          break;
        case '撤回':
          this.backDialogVisible = true;
          this.rowTemp = row;
          break;
        case '删除':
          this.delDialogVisible = true;
          this.rowTemp = row;
          break;
        default:
          break;
      }
    },

    // 操作按钮
    handleBtn(e) {
      switch (e) {
        case '筛选':
          this.getTaleData();
          break;
        case '新建站内信':
          this.g_tourl(`/saas/webSiteMsgManagement/add.html`);
          break;
        default:
          break;
      }
    },
    // 弹窗确认回调
    dialogEmit(e) {
      if (e) {
        this.reloadTable(true);
      }
    },
  },
};
</script>

<style lang="scss">
//分页
.pagination {
  margin-top: 12px;
  text-align: right;

  & ::v-deep .el-pager li.number {
    color: #606266;
  }

  & ::v-deep .el-pager li.active {
    color: #2f96ff !important;
  }

  & ::v-deep .el-input__inner {
    width: 46px;
    border-radius: 3px;
    height: 24px;
  }
}

// 编辑弹窗
.edit_box {
  .edit_content {
    .input {
      padding: 15px 0;
    }
    .btn {
      text-align: right;
      margin: 0;
    }
  }
}
</style>

<style lang="scss" scoped>
.webSiteMsgManagement {
  // 条件栏
  .nav-bar {
    padding-bottom: 20px;
    &::after {
      content: '';
      display: block;
      clear: both;
    }
    .nav-left {
      display: inline-block;
    }
    .nav-right {
      float: right;
    }
  }
  // 表格鼠标文字编辑悬浮
  .edit_able {
    position: relative;
    cursor: pointer;
    padding-right: 10px;
    &:hover {
      text-decoration: underline;
      color: #5fa4e8;
      &:after {
        position: absolute;
        //   content: '🖋🖊🖌🖍';
        content: '🖍';
        display: inline-block;
        font-size: 20px;
        padding-left: 5px;
      }
    }
  }
}
</style>
<style lang="scss">
.table_tooltip {
  max-width: 300px;
}
</style>
